import { useVehicleActions } from "../actions/vehicleActions"
import { useVehicleBuilders } from "../builders/vehicleBuilders"
import { useVehicleLoaders } from "../loaders/vehicleLoaders"

export const useVehicleService = () => {
    const { buildVehicle } = useVehicleBuilders()
    
    const vehicleLoaders = useVehicleLoaders()

    const { saveVehicle } = useVehicleActions()

    const archiveVehicle = async (vehicleId: string) => {
        const { loadVehicle } = vehicleLoaders()
        const vehicle = await loadVehicle(vehicleId, true)
        const archivedVehicle = buildVehicle({
            ...vehicle,
            archived: true
        })
        return saveVehicle(archivedVehicle)
    }

    return {
        archiveVehicle
    }
}
